import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import {
  MatchMenuItem as MatchMenuItemType,
  MENU_ITEM_TYPE,
} from 'app/modules/Navigation/types';

import { useTranslation } from 'app/lang';
import { accessMainScore } from 'app/lib/betting/accessMatchDetails';
import { MatchType } from 'app/lib/betting/betting-entities';
import { TeamId } from 'app/lib/betting/constants';
import { replacingHyphenOnDash } from 'app/lib/replaceDashSymbol';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';

import MatchObjectLabel from './MatchObjectLabel';
import MatchObjectScore from './MatchObjectScore';

import styles from '../../styles/LeftMenu.module.scss';

type MatchMenuItemProps = {
  entry: MatchMenuItemType;
};

const MatchMenuItem: React.FC<MatchMenuItemProps> = ({
  entry,
}) => {
  const { t } = useTranslation();

  const entryTitle = getDictionaryDataItems(t, entry.title);

  const scores = accessMainScore(entry.entity);
  const replacedMatchName = replacingHyphenOnDash(entryTitle);

  const firstTeamScore = scores?.get(TeamId.FIRST);
  const secondTeamScore = scores?.get(TeamId.SECOND);

  const isHeadToHeadMatch = entry?.entity?.type === MatchType.HEAD_TO_HEAD;
  const isOutrightMatch = entry?.entity?.type === MatchType.OUTRIGHT;

  const hasScores = typeof firstTeamScore === 'number' || typeof secondTeamScore === 'number';
  return (
    <li
      className={classNames(styles.matchMenuItem, {
        [styles.active]: entry.active,
      })}
      data-test="favorite-match">
      <Link
        to={entry.location}
        title={replacedMatchName}
        {...entry.dataGaValues}
        data-test="layer-menu-item"
        data-test-item-type={MENU_ITEM_TYPE.MATCH}
        data-test-item-key={entry.key}
        data-test-item-active={entry.active ? 'active' : undefined}>
        <div className={styles.labelsFavoriteAndScore}>
          <div className={styles.labelsAndFavoriteGrid}>
            {isHeadToHeadMatch && (
              <>
                <MatchObjectLabel number="1"
                                  name={entry.matchObjects.get(TeamId.FIRST)?.name} />
                <MatchObjectLabel number="2"
                                  name={entry.matchObjects.get(TeamId.SECOND)?.name} />
              </>
            )}

            {isOutrightMatch && (
              <div className={styles.label}>
                <MatchObjectLabel number="1"
                                  name={entry?.entity?.name} />
              </div>
            )}

          </div>
          {hasScores && !isOutrightMatch && (
            <div
              className={styles.scoresWrapper}>
              {typeof firstTeamScore === 'number' && (
                <MatchObjectScore number="1"
                                  value={firstTeamScore} />
              )}
              {typeof secondTeamScore === 'number' && (
                <MatchObjectScore number="2"
                                  value={secondTeamScore} />
              )}
            </div>
          )}
        </div>
      </Link>
    </li>
  );
};

export default MatchMenuItem;
